import { Component, ChangeDetectionStrategy } from "@angular/core";
import { PageComponent } from "@components/page/page.component";
import { TabComponent } from "@components/tabs/tab/tab.component";
import { TabsComponent } from "@components/tabs/tabs.component";
import { SandningsloggTexts } from "./sandningslogg.texts";
import { SearchPanelMaskinComponent } from "./search-panel-maskin/search-panel-maskin.component";
import { SearchPanelComponent } from "./search-panel/search-panel.component";

@Component({
    selector: "rask-sandninglogg",
    templateUrl: "./sandninglogg.component.html",
    styleUrls: ["./sandninglogg.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        PageComponent,
        TabsComponent,
        TabComponent,
        SearchPanelComponent,
        SearchPanelMaskinComponent
    ]
})
export class SandningloggComponent {
    texts = SandningsloggTexts.texts;
}
